import React from "react";
import "./question.css";

export default function QuestionBox({ children }) {
  return (
    <div className="custom-border-20 p-md-5 p-2 bg-worksheet question-box-container h-450px">
      {children}
    </div>
  );
}
